<div class="list">
  <div class="row">
    <div class="col-md-5 col-xs-12">
      <label for="">Accesorio</label>
    </div>
    <div class="col-md-2 col-xs-6">
      <label for="">Suma asegurada</label>
    </div>
  </div>
  <sc-accessory-item  *ngFor="let accessory of vehicleAccessories; index as i;"
    [selectedAccessory]="accessory"
    [accessoryOptions]="accessoryOptions$"
    [accessories]="vehicleAccessories"
    [index]="i">
  </sc-accessory-item>
</div>

<span (click)="add()" class="add-row">
    <span class="sc-icon icon-more-elipse"></span>
    <span style="text-decoration: underline;">Agregar otro accesorio</span>
</span>